
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["sumMapper","resolveDiceTotals","rollDice","calculateProbability"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "82134e6f861a7a815232.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			